import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { User, UserRole } from '../../models/user';

declare var google: any;

@Component({
  selector: 'app-login',
  imports: [],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements AfterViewInit {

  constructor(private loginService: LoginService, private router: Router) {}

  ngAfterViewInit(): void {
    this.initializeGoogleSignIn();
  }

  private initializeGoogleSignIn(): void {
    if (typeof google === 'undefined' || !google?.accounts?.id) {
      console.warn('Google Identity Services not available yet.');
      return;
    }

    google.accounts.id.initialize({
      client_id: '1044909932385-53ur8q9fktmmfpidf6b9lltsegodn3f9.apps.googleusercontent.com',
      callback: (response: any) => this.handleGoogleSignIn(response),
      auto_select: false
    });

    const buttonDiv = document.getElementById('loginLoginButtonDiv');
    if (buttonDiv) {
      google.accounts.id.renderButton(buttonDiv, { theme: 'outline', size: 'large' });
    }
  }

  handleGoogleSignIn(response: any) {
    this.loginService.login(response.credential).subscribe({
      next: (user: User) => {
        if (user.role === UserRole.Admin || user.role === UserRole.Agent || user.role === UserRole.Scouting || user.role === UserRole.Casting) {
          this.router.navigate(['agent']);
        } else if (user.role === UserRole.Creator) {
          this.router.navigate(['agent']);
        } else if (user.role === UserRole.Research) {
          this.router.navigate(['research']);
        }
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }
}
